import { resources } from '@/i18n'
import { initZodErrorMap } from '@/lib/zod-error-map'
import { RouterContext } from '@/main'
import { getLocale } from '@/stores/i18n'
import { themeAtom } from '@/stores/theme'
import { Sentry } from '@repo/sentry-config/frontend'
import { Toaster } from '@repo/ui/components'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import i18n from 'i18next'
import { useAtomValue } from 'jotai'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: getLocale(),
  resources,
  fallbackLng: 'en',
  debug: !!import.meta.env.DEV,
  interpolation: {
    escapeValue: false,
  },
  saveMissing: true,
  missingKeyHandler: (languages, namespace, key) => {
    Sentry.captureMessage(
      `Missing i18n key: "${key}" in namespace "${namespace}" for languages [${languages.join(', ')}]`,
      'warning',
    )
  },
})

// Initialize Zod with translated error messages
initZodErrorMap()

// The toaster sits outside the module tree that carries ThemeProvider, so it reads the stored theme itself
function RootComponent() {
  const theme = useAtomValue(themeAtom)

  return (
    <>
      <div className="text-foreground text-sm subpixel-antialiased">
        <Outlet />
        <Toaster closeButton theme={theme} />
      </div>

      {import.meta.env.DEV && <TanStackRouterDevtools />}
      {import.meta.env.DEV && <ReactQueryDevtools />}
    </>
  )
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})
